import Score from 'util/Score';

export default class SubjectModel extends Backbone.Model {

    get defaults() {
        return {
            isVisible: true,
        }
    }

    preinitialize() {
        this.constructor.type = 'subject'
    }

    initialize() {
        this.set({
            name: this.get('subject')
        });
    }

    /**
     * This function will return the parent subject. It will select the subject with
     * the same id as the parent subject id
     *
     * @return {SubjectModel}     Backbone model of parent subject
     */
    getParent() {
        return this.collection.findWhere({
            id: this.get('parent_subject_id')
        });
    }

    /**
     * This function will get all the children of this subject. It will select the children
     * by using it's own Id to filter subject with this id as parent_subject_id.
     *
     * @return {SubjectsCollection|Backbone.Collection}              Collection of child subjects
     */
    getChildren() {
        // Create new instance of the collection of the type the model is a part of with only the child models.
        // This will be the type SubjectsCollection in most cases, sbut could also be a modified version for
        // special use cases.
        return new this.collection.constructor(this.collection.where({
            parent_subject_id: this.get('id')
        }));
    }

    /**
     * This function will get all the siblings of this subject. It will select the siblings
     * by selecting subjects with the same parent subject id.
     *
     * @return {SubjectsCollection|Backbone.Collection}              Collection of sibling subjects
     */
    getSiblings() {
        // Create new instance of the collection of the type the model is a part of with only the sibling models.
        // This will be the type SubjectsCollection in most cases, but could also be a modified version for
        // special use cases.
        return new this.collection.constructor(this.collection.where({
            parent_subject_id: this.get('parent_subject_id')
        }));
    }

    hasParent() {
        return (this.getParent() !== undefined);
    }

    hasChildren() {
        return (this.getChildren().length > 0);
    }

    hasSiblings() {
        return (this.getSiblings().length > 0);
    }

    getScore() {
        return (_.isEmpty(this.get('averageScore')) ? this.get('score') : this.get('averageScore').score_avg) || 0
    }

    getScoreColor() {
        const hasSufficientTasksMade = this.get('goal_tasks_made')

        if (!hasSufficientTasksMade) {
            return
        }

        return Score.getColor(this.getScore())
    }

    getScoreLabel() {
        const hasSufficientTasksMade = this.get('goal_tasks_made')
        if (hasSufficientTasksMade) {
            return window.i18n.sprintf(window.i18n.gettext('<b>%s%%</b> score'), (this.getScore() * 100).toFixed())
        }
        return window.i18n.gettext('no score')
    }

    getTasksMade() {
        return (
            _.isEmpty(this.get('averageScore')) ? this.get('tasks_made') : this.get('averageScore').tasks_avg
        ) || 0
    }

}
